import React from 'react';

// Renders nothing until `open` is first true, then keeps its children mounted
// (so a popup keeps its state and closing animation after that). Pages that
// hold many popups - most never opened - skip rendering them all on load.
const MountWhenOpened: React.FC<{ open: boolean; children: React.ReactNode }> = ({ open, children }) => {
    const [opened, setOpened] = React.useState(open);
    if (open && !opened) setOpened(true);
    return opened ? <>{children}</> : null;
};

export default MountWhenOpened;
